/** Native push belongs to apps/mobile. Browser authentication keeps these no-op hooks. */
export function isNativeAndroid(): boolean { return false; }
export function isPushNotificationsEnabled(): boolean { return false; }
export async function initPushNotifications(): Promise<void> {}
export async function unregisterCurrentDevice(): Promise<void> {}
